module.exports = __webpack_public_path__ + "img/dogu_logo.dbaaf5ef.png";